<template>
  <router-link to="/" class="tf-logo">
    🌄 Town Faker
  </router-link>
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<style scoped>
.tf-logo {
  font-size: 24px;
  display: flex;
  align-items: center;
  line-height: 1;
  font-family: var(--head-font);
}
</style>